import { PageHeader } from "@ant-design/pro-components";
import { CopyAllOutlined, Message } from "@mui/icons-material";
import { Alert, Button, Card, Form, Input, message, Select, Textarea } from "antd";
import { memo, useEffect, useState } from "react";
import api from "../../../api/api";
import styles from "./SendPredefinedSms.module.css";

const SendPredefinedSms = () => {
  const [form] = Form.useForm();
  const [lines, setLines] = useState({});
  const [predefinedTexts, setPredefinedTexts] = useState({});
  const [messageTextArea, setMessageTextArea] = useState("");

  const [result, setResult] = useState({
    message: "",
    type: "",
  });

  useEffect(() => {
    loadLines();
    loadPredefinedTexts();
  }, []);

  const loadLines = () => {
    api.get("/smsline/list?isKavenegarLookup=false").then((res) => {
      const data = res.data;
      setLines(data);
    });
  };

  const loadPredefinedTexts = () => {
    api.get("/smspredefined/list").then((res) => {
      const data = res.data.filter((item) => item.active);
      setPredefinedTexts(data);
    });
  };

  const selectPredefined = (predefinedId) => {
    predefinedTexts.forEach((predefined) => {
      if (predefined.id == predefinedId) setMessageTextArea(predefined.text);
    });
  };

  const sendRequest = () => {
    const formData = form.getFieldValue();

    setResult({ message: "", type: "" });
    api
      .post("/smsline/sendpredefined", formData)
      .then((res) => {
        if (res.data?.status === "Sent") {
          setResult({
            message: "ارسال پیامک با موفقیت انجام شد.",
            type: "success",
          });
        } else {
          setResult({
            message: "مشکلی در ارسال پیامک به سرویس دهنده پیش آمده است.",
            type: "error",
          });
        }
      })
      .catch((error) => {
        let messageText = error.response.data?.error?.message;
        message.error(messageText);
        setResult({
          message: messageText,
          type: "error",
        });
      });
  };

  return (
    <div className={styles.CopyRoadmap}>
      <PageHeader title="ارسال پیامک" avatar={{ icon: <Message />, size: "large", style: { paddingTop: "8px" } }} />

      <Card className={styles.Form}>
        <Form form={form} name="validateOnly" layout="vertical" autoComplete="off">
          {lines.length > 0 && (
            <Form.Item
              name="line"
              label="خط ارسالی"
              rules={[
                {
                  required: true,
                },
              ]}
              initialValue={Object.values(lines).find((item) => item.isDefault)?.id}
            >
              <Select
                style={{
                  width: "100%",
                }}
                placeholder="خط ارسالی"
                options={Object.values(lines).map((line) => {
                  return { label: line.number + " - " + line.provider_title, value: line.id };
                })}
              />
            </Form.Item>
          )}

          <Form.Item
            name="mobile"
            label="موبایل"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          {predefinedTexts.length > 0 && (
            <Form.Item
              name="predefined"
              label="قالب"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                style={{
                  width: "100%",
                }}
                placeholder="قالب"
                onChange={selectPredefined}
                options={Object.values(predefinedTexts).map((predefinedText) => {
                  return { label: predefinedText.key + " | " + predefinedText.text, value: predefinedText.id };
                })}
              />
            </Form.Item>
          )}

          <div className={styles.MessageTextareaContainer}>
            <label>متن پیام</label>
            <Input.TextArea name="message" value={messageTextArea} readOnly rows={5} />
          </div>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => {
                sendRequest();
              }}
            >
              ارسال پیام
            </Button>
          </Form.Item>

          {result.message && <Alert message={result.message} type={result.type} />}
        </Form>
      </Card>
    </div>
  );
};

export default memo(SendPredefinedSms);
